import { render, staticRenderFns } from "./proRecord.vue?vue&type=template&id=a2600c50&scoped=true"
import script from "./proRecord.vue?vue&type=script&lang=js"
export * from "./proRecord.vue?vue&type=script&lang=js"
import style0 from "./proRecord.vue?vue&type=style&index=0&id=a2600c50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2600c50",
  null
  
)

export default component.exports